


export const API_URL = 'https://api-movicel.technext.ao/api';